import { memo, useCallback, MouseEventHandler } from 'react';
import classNames from 'classnames';

import { ReactComponent as CloseIcon } from 'assets/images/close.svg';

import styles from './styles.module.scss';

type Props = {
  containerClassName: string;
  onClose: MouseEventHandler<HTMLDivElement | HTMLButtonElement>;
};

export const Modal: React.FC<Props> = memo(function Modal({
  containerClassName,
  children,
  onClose,
}) {
  const handleModalContainerClick: MouseEventHandler<HTMLDivElement> = useCallback((event) => {
    event.stopPropagation();
  }, []);

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div
        className={classNames(styles.container, containerClassName)}
        onClick={handleModalContainerClick}>
        <button type="button" onClick={onClose}>
          <CloseIcon />
        </button>
        {children}
      </div>
    </div>
  );
});
